import { ITile } from "@faire/web-api--source/indigofair/data/ITile";

export const trackBrandTileHelper = (tile: ITile) => {
  return (
    tile?.brand_tile !== undefined || tile?.brand_tile_with_action !== undefined
  );
};
